import OverallPlanComplete from './components/OverallPlanComplete';
import OverallPlanStatuses from './components/OverallPlanStatuses';
import PlanStatusByMonth from './components/PlanStatusByMonth';
import OverallPlanFocusClassification from './components/OverallPlanFocusClassification';
import VCByMonth from './components/VCByMonth';
import EPByMonth  from './components/EPByMonth' ;
import HHHMByMonth  from './components/HHHMByMonth' ;
import USAMap  from './components/CompleteByProvince' ;
//import USAMap  from './components/USAMap' ;




import "./App.css";  // Import your CSS file

function DashboardLayout({ children }) {
  return (
    <div className="dashboard">
      <table border={1}>
        <tbody>
          <tr>
            <td className="center-cell" width={"250"}>{children[0]}</td>
            <td className="center-cell" width={"40%"}>{children[1]}</td>
            <td className="center-cell" width={"40%"}>{children[2]}</td>
          </tr>
          <tr>
            <td className="center-cell"rowSpan={2} >{children[7]}</td>
            <td className="center-cell" >{children[5]}</td>
            <td className="center-cell" >{children[3]}</td>
          </tr>
          <tr>
            <td className="center-cell" >{children[4]}</td>
            <td className="center-cell" >{children[6]}</td>
          </tr>
          {/* ... other table rows can be added here ... */}
        </tbody>
      </table>
    </div>
  );
}

function App() {
  // ... (your other code)

  return (
    <DashboardLayout>
      <OverallPlanComplete />
      <OverallPlanStatuses />
      <PlanStatusByMonth/>
      <OverallPlanFocusClassification/>
      <VCByMonth/>
      <EPByMonth/>
      <HHHMByMonth/>
      <USAMap/>
    </DashboardLayout>
  );
}
/*
function App() {
  return (
    <div className="dashboard">
      <table border={1}>
        <tr>
          <td className="center-cell">
            <OverallPlanComplete />
          </td>
          <td className="center-cell">
            <div>
              <OverallPlanStatuses />
            </div>
          </td>
        </tr>
      </table>
    </div>
  );
}
  */
export default App;

